module.exports = __webpack_public_path__ + "img/sales.cd60f758.svg";